import React from 'react';
import { ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline';

const Messages: React.FC = () => {
  return (
    <div className="section-card">
      <h1 className="section-title">Messages</h1>
      <p className="section-description">
        Manage and respond to contact messages from website visitors. Track message status and maintain communication records.
      </p>

      <div className="mt-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Features
        </h2>
        <div className="space-y-4">
          <div className="feature-item">
            <ChatBubbleLeftRightIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Message Management</h3>
              <p className="feature-description">
                Handle contact messages with the following capabilities:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>View message details including name, email, phone, and message content</li>
                <li>Mark messages as read/unread with status toggle</li>
                <li>Delete individual messages</li>
                <li>Bulk delete multiple messages</li>
                <li>View message statistics and counts</li>
              </ul>
            </div>
          </div>

          <div className="feature-item">
            <ChatBubbleLeftRightIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Message List</h3>
              <p className="feature-description">
                View and manage messages in a table format with the following columns:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Name (truncated to 60 characters)</li>
                <li>Email address</li>
                <li>Read/Unread status toggle</li>
                <li>Actions (View and Delete)</li>
              </ul>
            </div>
          </div>

          <div className="feature-item">
            <ChatBubbleLeftRightIcon className="feature-icon" />
            <div className="feature-text">
              <h3 className="feature-title">Message Details</h3>
              <p className="feature-description">
                View complete message information in a modal:
              </p>
              <ul className="list-disc list-inside mt-2 text-gray-600">
                <li>Full name</li>
                <li>Email address</li>
                <li>Phone number</li>
                <li>Complete message content</li>
                <li>Read/Unread status toggle</li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-8">
        <h2 className="text-xl font-semibold text-gray-800 mb-4">
          Best Practices
        </h2>
        <div className="bg-blue-50 p-4 rounded-lg">
          <ul className="list-disc list-inside space-y-2 text-blue-800">
            <li>Regularly check for new unread messages</li>
            <li>Mark messages as read after responding</li>
            <li>Keep the message list organized by using the status toggle</li>
            <li>Delete resolved messages to maintain a clean inbox</li>
            <li>Monitor message statistics to track communication volume</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Messages; 